import { controls } from "../../controls";

const rp623 = {
  label: "OSC 5.5",
  pageLabel: "OSC 5.5 -Top 20 Housing Loans",
  starting: true,
  url: "rp623",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),
        
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-3 "}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  
  form:[],

  history: {
    perPage: 10,
    reportHeader: "OSC 5.5\nTop 20 Housing Loans",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Name of the borrower",
        accessor: "descn",
        rwidth:"*"
      },
      {
        Header: "Date of sanction",
        accessor: "opendate",
        type:"date",
        width: 200,
        rwidth: 75
      },
      {
        Header: "Amount",
        columns: [
          {
            Header: "Sanctioned",
            accessor: "sanction",
            type:"currency",
            width: 200,
            rwidth: 75
          },
          {
            Header: "Disbursed",
            accessor: "disbamt",
            type:"currency",
            width: 200,
            rwidth: 75
          },
          {
            Header: "Outstanding",
            accessor: "balance",
            type:"currency",
            width: 200,
            rwidth: 75
          }
        ]
      }
    ]
  }
};

export default rp623;